import { ApiStatus, Action } from 'common/enums';

import { PreviewDataState } from 'common/models/data/previewData.model';

const initialPreviewDataState: PreviewDataState = {
    previewData: {},
    fieldErrors: [],
    deleteApiResponse: {
        status: ApiStatus.NONE
    },
    editStatus: {},
    editData: {},
    errorCount: -1,
    isAtleastOneErrorFixed: false,
    searchList: {},
    currentAction: Action.Default,
    errorCountFetchStatus: {}
};

export default initialPreviewDataState;
